module.exports = __webpack_public_path__ + "static/media/pause-play-circle.f3945576.svg";